import { UAParser } from 'ua-parser-js'

const { device } = new UAParser().getResult()
const isMobile = ['mobile', 'tablet'].includes(device.type)

const DEFAULT_COUNTRY_CODE = '55'

export default function (phone, message, phoneCountryCode) {
  const userAgent = navigator.userAgent
  const iOS = !!userAgent.match(/iPhone|iPad|iPod/)

  const text = encodeURIComponent(message)
  // Aceita '351' ou '+351'; sem DDI informado, assume Brasil
  const countryCode = String(phoneCountryCode || '').replace(/\D/g, '') || DEFAULT_COUNTRY_CODE

  const api = isMobile ? 'https://api.whatsapp.com' : 'https://web.whatsapp.com'
  const url = `${api}/send?phone=${countryCode}${phone}&text=${text}`

  if (isMobile) {
    if (iOS) {
      openLinkExternally(url)
    } else {
      window.open(url)
    }
  } else {
    openLinkInNewTab(url)
  }
}

const openLinkInNewTab = url => {
  if (typeof document === 'undefined') return // Not on a browser!
  const win = window.open(url, '_blank')
  win.focus()
}

const openLinkExternally = (url) => {
  // Cria um elemento <a> temporário para simular um clique direto do usuário
  const a = document.createElement('a')
  a.href = url
  a.target = '_blank' // Abre o link em uma nova aba
  a.rel = 'noreferrer noopener' // Previne problemas de segurança

  // Simula um clique no elemento
  document.body.appendChild(a)
  a.click()

  // Limpa o elemento temporário
  document.body.removeChild(a)
}



// WEBPACK FOOTER //
// ./src/services/sendMessageWPP.js